import React from 'react';
import { IonFab, IonFabButton } from '@ionic/react';
import { Add } from '@mui/icons-material';
import { Link } from '$gcomponents/primitives';

interface FabButtonProps {
  onClick?: Function;
  color?: string;
  icon?: React.ReactNode;
  ver?: any;
  hor?: any;
  testId?: string;
  route?: string;
  isHidden?: boolean;
  size?: 'small';
  className?: string;
}

const FabButton: React.FC<FabButtonProps> = ({
  color = 'primary',
  ver = 'top',
  hor = 'end',
  testId = 'fab-button',
  icon,
  isHidden = false,
  onClick,
  className = '',
  size = 'small',
  route,
}) => {
  if (isHidden) return null;
  const props = {
    ...(onClick && { onClick: () => onClick() }),
  };
  const Button = (
    <IonFabButton color={color} size={size} {...props}>
      {icon || <Add />}
    </IonFabButton>
  );
  return (
    <IonFab
      vertical={ver}
      data-testid={testId || 'fab-button'}
      horizontal={hor}
      slot="fixed"
      className={`no-print ${className}`}>
      {route ? <Link route={route}>{Button}</Link> : Button}
    </IonFab>
  );
};

export default FabButton;
